import { TimePicker } from "components";
import { DoorsFormState } from "shared/utils/fieldsHelper/companyFields";
import React from "react";

interface Props {
  value: DoorsFormState;
  onChange: (value: DoorsFormState) => void;
}

export const DoorsEdit = (props: Props) => {
  return <div className="flex-column gap">
    <div className="flex gap">
      <div>
        <TimePicker
          canBeEmpty
          value={props.value.open}
          onChange={(value) => props.onChange({ ...props.value, open: value })}
        />
      </div>
      <div>
        {RESX.Venue.Open}
      </div>
    </div>
    <div className="flex gap">
      <div>
        <TimePicker
          canBeEmpty
          value={props.value.close}
          onChange={(value) => props.onChange({ ...props.value, close: value })}
        />
      </div>
      <div>
        {RESX.Venue.Close}
      </div>
    </div>
  </div>
}
